import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import React from "react";
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  otp: string;
  otpAuthToken: string;
  userAccountID: string;
  labelInfo: string;
  toMessage: string;
  isFromForgotPassword: boolean;

  otpValues: Array<string>;
  isVerifyDisabled: boolean;
  inputRefs: React.RefObject<unknown>[];
  number: string;
  otpError: string;
  showResendText: boolean;
  timer: number;
  isLogin: boolean;
  isRegistration: boolean;
  callingCode: string;
  rawPhoneNumber: string;

  emailAddress: string;
  phoneNumber: string;
  countryCodeSelected: string;

  // Customizable Area End
}

export interface SS {
  // Customizable Area Start
  id: any;
  // Customizable Area End
}

export default class OTPInputAuthController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  otpAuthApiCallId: any;
  btnTxtSubmitOtp: string;
  placeHolderOtp: string;
  labelInfo: string = "";
  submitButtonColor: any = configJSON.submitButtonColor;

  VerifyotpAuthApiCallId: string = "";
  loginVerifyOtpApiCallId: string = "";
  intervalId: ReturnType<typeof setTimeout> | null = null;
  resendOtpApiCallId: string = "";
  loginResendOtpApiCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      // Customizable Area End
    ];

    this.receive = this.receive.bind(this);

    runEngine.attachBuildingBlock(this, this.subScribedMessages);

    // Customizable Area Start
    this.state = {
      otp: "",
      otpAuthToken: "",
      userAccountID: "",
      labelInfo: configJSON.labelInfo,
      toMessage: "",
      isFromForgotPassword: false,

      otpValues: ["", "", "", ""],
      isVerifyDisabled: true,
      inputRefs: [React.createRef(), React.createRef(), React.createRef(), React.createRef()],
      number: "",
      otpError: "",
      showResendText: true,
      timer: 0,
      isLogin: false,
      isRegistration: false,
      callingCode: "",
      rawPhoneNumber: "",

      emailAddress: "",
      phoneNumber: "",
      countryCodeSelected: "",
    };

    this.btnTxtSubmitOtp = configJSON.btnTxtSubmitOtp;
    this.placeHolderOtp = configJSON.placeHolderOtp;
    // Customizable Area End
  }

  async receive(from: String, message: Message) {
    // Customizable Area Start
    this.showNavigationData(message)
    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    let responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
    
    if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      this.otpAuthApiCallId != null &&
      this.otpAuthApiCallId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
       responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (
        responseJson &&
        (responseJson.messages ||
          (responseJson.meta && responseJson.meta.token))
      ) {
        if (responseJson.meta && responseJson.meta.token) {
          this.setState({
            otpAuthToken: responseJson.meta.token,
          });
        }

        if (this.state.isFromForgotPassword) {
          // runEngine.debugLog("about to send NavigationNewPasswordMessage");
          const msg: Message = new Message(
            getName(MessageEnum.NavigationNewPasswordMessage)
          );
          msg.addData(
            getName(MessageEnum.AuthTokenDataMessage),
            this.state.otpAuthToken
          );

          msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);

          this.send(msg);
        } else {
          const msg: Message = new Message(
            getName(MessageEnum.NavigationMobilePhoneAdditionalDetailsMessage)
          );

          msg.addData(
            getName(MessageEnum.AuthTokenDataMessage),
            this.state.otpAuthToken
          );

          msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);

          this.send(msg);
        }
      } else {
        //Check Error Response
        this.parseApiErrorResponse(responseJson);
      }

      var errorReponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (errorReponse != null) {
        this.parseApiCatchErrorResponse(errorReponse);
      }
    } else if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      const phoneAuthToken = message.getData(
        getName(MessageEnum.AuthTokenDataMessage)
      );

      const phoneNumber = message.getData(
        getName(MessageEnum.AuthTokenPhoneNumberMessage)
      );

      const forgotPasswordBool = message.getData(
        getName(MessageEnum.EnterOTPAsForgotPasswordMessage)
      );

      const emailValue = message.getData(
        getName(MessageEnum.AuthTokenEmailMessage)
      );

      const userAccountID = phoneNumber ? "" + phoneNumber : "" + emailValue;

      let updatedLabel = this.state.labelInfo;
      if (userAccountID && userAccountID !== "undefined") {
        updatedLabel = updatedLabel.replace("phone", userAccountID);
      }

      this.setState({
        otpAuthToken:
          phoneAuthToken && phoneAuthToken.length > 0
            ? phoneAuthToken
            : this.state.otpAuthToken,
        userAccountID: userAccountID,
        labelInfo: updatedLabel,
        isFromForgotPassword:
          forgotPasswordBool === undefined
            ? this.state.isFromForgotPassword
            : forgotPasswordBool,
      });
    }
    else if ( apiRequestCallId === this.VerifyotpAuthApiCallId || apiRequestCallId === this.resendOtpApiCallId || apiRequestCallId === this.loginVerifyOtpApiCallId) {
      if (responseJson?.errors && Array.isArray(responseJson.errors) && responseJson.errors.length > 0 && responseJson.errors[0].message) {
        this.setState({ otpError: "Incorrect OTP. Try again or request a new code" });
      }
      if(responseJson?.data || responseJson?.account_id){
        localStorage.setItem('token', responseJson?.data?.token);
        this.props.navigation.navigate("Dashboard");
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start

  async componentDidMount(): Promise<void> {
    const storedFullPhoneNumber = sessionStorage.getItem('fullPhoneNumber');
    if(storedFullPhoneNumber){
      this.setState({
        number: storedFullPhoneNumber,
      })
    }

    this.intervalId = setInterval(() => {
      if (this.state.timer > 0) {
        this.setState({ timer: this.state.timer - 1 });
      } else {
        this.setState({ showResendText: false, timer: 0, isVerifyDisabled: false });
      }
    }, 1000);
  }

  async componentWillUnmount(): Promise<void> {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }

  showNavigationData = (message: Message) => {
    if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      let data = message.getData(getName(MessageEnum.NavigationPayLoadMessage))
      this.setState({isLogin: data?.isLogin});
      this.setState({isRegistration: data?.isRegistration});
      this.setState({callingCode: data?.callingCode});
      this.setState({rawPhoneNumber: data?.rawPhoneNumber});

      this.setState({emailAddress: data?.emailAddress});
      this.setState({phoneNumber: data?.phoneNumber});
      this.setState({countryCodeSelected: data?.countryCodeSelected});
    }
  };

  handleResendOTP = () => {
    this.setState({ otpError: "", showResendText: true, otpValues: ["", "", "", ""], timer: 30 }, () => {
      // Clear existing interval if any
      if (this.intervalId !== null) {
        clearInterval(this.intervalId);
      }
      
      // Start new timer
      this.intervalId = setInterval(() => {
        if (this.state.timer > 0) {
          this.setState({ timer: this.state.timer - 1 });
        } else {
          this.setState({ 
            showResendText: false, 
            timer: 0,
            isVerifyDisabled: false 
          });
        }
      }, 1000);
    });

    if(this.state.isRegistration){
    const headers = {
      "Content-Type": configJSON.apiVerifyOtpContentType
    };

     
     const { number } = this.state;

     
     const requestBody = {
      full_phone_number: number,
    }

    const handleResendOtpAuthMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.resendOtpApiCallId = handleResendOtpAuthMsg.messageId;

    handleResendOtpAuthMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlResendOtpAuth
    );

    handleResendOtpAuthMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    handleResendOtpAuthMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.resendOtpAuthApiMethodType
    );

     
    handleResendOtpAuthMsg.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(requestBody)
  );

    runEngine.sendMessage(handleResendOtpAuthMsg.id, handleResendOtpAuthMsg);

}
else if(this.state.isLogin){

  const headers = {
    "Content-Type": configJSON.apiVerifyOtpContentType
  };
  
   const requestBody = {
    data: {
        type: "logins",
        attributes: {
            country_code: "+" + this.state.callingCode,
            phone_number: this.state.rawPhoneNumber,
        }
    }
};

  const handleResendOtpAuthMsg = new Message(
    getName(MessageEnum.RestAPIRequestMessage)
  );
  this.loginResendOtpApiCallId = handleResendOtpAuthMsg.messageId;

  handleResendOtpAuthMsg.addData(
    getName(MessageEnum.RestAPIResponceEndPointMessage),
    configJSON.urlLoginResendOtpAuth
  );

  handleResendOtpAuthMsg.addData(
    getName(MessageEnum.RestAPIRequestHeaderMessage),
    JSON.stringify(headers)
  );
  handleResendOtpAuthMsg.addData(
    getName(MessageEnum.RestAPIRequestMethodMessage),
    configJSON.resendOtpAuthApiMethodType
  );

   
  handleResendOtpAuthMsg.addData(
    getName(MessageEnum.RestAPIRequestBodyMessage),
    JSON.stringify(requestBody)
);

  runEngine.sendMessage(handleResendOtpAuthMsg.id, handleResendOtpAuthMsg);

}
  }

  handleVerify = () => {

    
    this.setState({ otpError: "", timer: 0, showResendText: true });

    if (!this.state.isVerifyDisabled) {
      const otp = this.state.otpValues.join('');
      

      if (this.state.isRegistration) {    
      const headers = {
        "Content-Type": configJSON.apiVerifyOtpContentType
      };
  
       const requestBody = {
        "otp_code": otp
      }
  
      const handleOtpAuthMsg = new Message(
        getName(MessageEnum.RestAPIRequestMessage)
      );
      this.VerifyotpAuthApiCallId = handleOtpAuthMsg.messageId;
  
      handleOtpAuthMsg.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        configJSON.urlVerifyOtpAuth
      );
  
      handleOtpAuthMsg.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify(headers)
      );
      handleOtpAuthMsg.addData(
        getName(MessageEnum.RestAPIRequestMethodMessage),
        configJSON.VerifyOtpAuthApiMethodType
      );
  
       
      handleOtpAuthMsg.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        JSON.stringify(requestBody)
    );
  
      runEngine.sendMessage(handleOtpAuthMsg.id, handleOtpAuthMsg);

      }
      else if (this.state.isLogin) {

        const headers = {
          "Content-Type": configJSON.apiVerifyOtpContentType
        };
    
         const requestBody = {
          "otp_code": otp
        }
    
        const handleOtpAuthMsg = new Message(
          getName(MessageEnum.RestAPIRequestMessage)
        );
        this.loginVerifyOtpApiCallId = handleOtpAuthMsg.messageId;
    
        handleOtpAuthMsg.addData(
          getName(MessageEnum.RestAPIResponceEndPointMessage),
          configJSON.urlLoginVerifyOtpAuth
        );
    
        handleOtpAuthMsg.addData(
          getName(MessageEnum.RestAPIRequestHeaderMessage),
          JSON.stringify(headers)
        );
        handleOtpAuthMsg.addData(
          getName(MessageEnum.RestAPIRequestMethodMessage),
          configJSON.VerifyOtpAuthApiMethodType
        );
    
         
        handleOtpAuthMsg.addData(
          getName(MessageEnum.RestAPIRequestBodyMessage),
          JSON.stringify(requestBody)
      );
    
        runEngine.sendMessage(handleOtpAuthMsg.id, handleOtpAuthMsg);

      }
    }
  };

  handleOTPChange = (index: number, value: string) => {
    // Only allow digits
    if (!/^\d*$/.test(value)) return;
  
    const newOTPValues = [...this.state.otpValues];
    newOTPValues[index] = value;
    
    this.setState({
      otpValues: newOTPValues,
      isVerifyDisabled: newOTPValues.some(val => !val)
    }, () => {
      // Auto focus next input immediately when a digit is entered
      if (value.length === 1 && index < 3 && this.state.inputRefs[index + 1].current) {
        (this.state.inputRefs[index + 1].current as HTMLInputElement).focus();
      }
    });
  };

  handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Backspace') {
      const currentInput = e.target as HTMLInputElement;
      if (currentInput.value === '') {
        e.preventDefault();
        if (index > 0 && this.state.inputRefs[index - 1].current) {
          this.handleOTPChange(index - 1, '');
          (this.state.inputRefs[index - 1].current as HTMLInputElement).focus();
        }
      }
    }
  };
  

  handleBack = () => {
    if(this.state.isRegistration){
          const payloadData = { showProfile: true, emailAddress: this.state.emailAddress, phoneNumber: this.state.phoneNumber, countryCodeSelected: this.state.countryCodeSelected, callingCode: this.state.callingCode}
          const msgNavigation = new Message(getName(MessageEnum.NavigationMessage));
          msgNavigation.addData(getName(MessageEnum.NavigationTargetMessage), "EmailAccountRegistration");
          msgNavigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
          const raiseMessage: Message = new Message(getName(MessageEnum.NavigationPayLoadMessage));
          raiseMessage.addData(getName(MessageEnum.NavigationPayLoadMessage), payloadData);
          msgNavigation.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
          this.send(msgNavigation);
    }
    if(this.state.isLogin){
      const payloadData = { showProfile: true }
      const msgNavigation = new Message(getName(MessageEnum.NavigationMessage));
      msgNavigation.addData(getName(MessageEnum.NavigationTargetMessage), "EmailAccountLoginBlock");
      msgNavigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
      const raiseMessage: Message = new Message(getName(MessageEnum.NavigationPayLoadMessage));
      raiseMessage.addData(getName(MessageEnum.NavigationPayLoadMessage), payloadData);
      msgNavigation.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
      this.send(msgNavigation);
}
  };

  async submitOtp() {
    if (!this.state.otp || this.state.otp.length === 0) {
      this.showAlert(configJSON.errorTitle, configJSON.errorOtpNotValid);
      return;
    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    if (this.state.isFromForgotPassword) {
      // console.log("entered is from forgot password!");
      const header = {
        "Content-Type": configJSON.apiVerifyOtpContentType,
      };

      //GO TO REQUEST STATE
      this.otpAuthApiCallId = requestMessage.messageId;

      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        configJSON.apiVerifyForgotPasswordOtpEndPoint
      );

      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify(header)
      );

      const data = {
        token: this.state.otpAuthToken ? this.state.otpAuthToken : "",
        otp_code: this.state.otp ? this.state.otp : "",
      };

      const httpBody = {
        data: data,
      };

      //requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "POST");

      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        JSON.stringify(httpBody)
      );
    } else {
      const headers = {
        "Content-Type": configJSON.apiVerifyOtpContentType,
        token: this.state.otpAuthToken,
      };

      this.otpAuthApiCallId = requestMessage.messageId;

      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        configJSON.apiVerifyOtpEndPoint + this.state.otp
      );

      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify(headers)
      );

      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        JSON.stringify(JSON.stringify({}))
      );
    }

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiVerifyOtpMethod
    );
    // console.log("requestMessage.id is: " + requestMessage.id);
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  btnSubmitOTPProps = {
    onPress: () => this.submitOtp(),
  };

  txtMobilePhoneOTPWebProps = {
    onChangeText: (text: string) => this.setState({ otp: text }),
  };

  txtMobilePhoneOTPMobileProps = {
    ...this.txtMobilePhoneOTPWebProps,
    keyboardType: "numeric",
  };

  txtMobilePhoneOTPProps = this.isPlatformWeb()
    ? this.txtMobilePhoneOTPWebProps
    : this.txtMobilePhoneOTPMobileProps;

  // Customizable Area End
}
